// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f05c4c2","455":"f2c5f4a3","977":"7a453675"}[chunkId] + ".chunk.js";
};